
import React, { useState } from 'react';
import AnimateInView from '@/components/ui/animate-in-view';
import SectionHeading from '@/components/ui/section-heading';

interface FAQ {
  question: string;
  answer: string;
}

const faqs: FAQ[] = [
  {
    question: "How deep is the fiber optic cable buried?",
    answer: "The cable is typically buried 15-30cm deep, depending on your soil type and specific security requirements."
  }, 
  {
    question: "Will landscaping or gardening affect the system?",
    answer: "Normal gardening activities won't trigger the system. Our AI distinguishes between routine maintenance and potential threats."
  }, 
  {
    question: "How quickly can the system be installed?",
    answer: "For a typical residential property, installation takes 1-3 days depending on terrain and perimeter length."
  }
];

const FibreFAQ = () => {
  const [expandedFaq, setExpandedFaq] = useState<number | null>(null);

  return (
    <section aria-labelledby="faq-heading" className="section bg-white py-[60px]">
      <div className="container mx-auto max-w-3xl">
        <AnimateInView>
          <SectionHeading 
            title="Frequently Asked Questions"
            className="text-center mb-8"
            titleClassName="text-forti-fi-teal"
          />
        </AnimateInView>
        
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <AnimateInView key={index} delay={100 * index}>
              <div className="border border-forti-fi-lavender/30 rounded-lg overflow-hidden">
                <button 
                  className="w-full p-4 text-left flex justify-between items-center bg-white hover:bg-forti-fi-background/50 transition-colors" 
                  onClick={() => setExpandedFaq(expandedFaq === index ? null : index)}
                >
                  <span className="font-medium text-forti-fi-teal">{faq.question}</span>
                  <span className="text-forti-fi-teal text-xl">
                    {expandedFaq === index ? '−' : '+'}
                  </span>
                </button>
                
                {expandedFaq === index && (
                  <div className="p-4 pt-0 bg-white">
                    <p className="text-forti-fi-charcoal">{faq.answer}</p>
                  </div>
                )}
              </div>
            </AnimateInView>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FibreFAQ;
